export default function weightCalculator() {
  const weightSlider = document.querySelector('#weight-slider');
  const weightInput = document.querySelector('#current-weight');
  const weightLossAmount = document.querySelector('#weight-loss-amount');
  const weightLossPercentage = document.querySelector('#weight_loss_percentage').value;
  const minWeight = document.querySelector('#min_weight').value;
  const maxWeight = document.querySelector('#max_weight').value;
  const weightSliderProgress = document.querySelector('#weight-slider-progress');

  /**
   * Calculate weight loss
   */
  function updateWeightLoss() {
    const currentWeight = parseFloat(weightInput.value) || 0;
    const exactWeightLoss = (currentWeight * weightLossPercentage) / 100;
    const hasDecimal = exactWeightLoss % 1 !== 0;
    weightLossAmount.textContent = hasDecimal ? Math.ceil(exactWeightLoss) : Math.round(exactWeightLoss);
    updateProgress();
  }

  /**
   * Validate input and update slider
   */
  function validateInput() {
    let numValue = parseFloat(weightInput.value.trim()) || 0;

    if (numValue < minWeight) {
      numValue = minWeight;
    } else if (numValue > maxWeight) {
      numValue = maxWeight;
    }

    weightInput.value = numValue;
    weightSlider.value = numValue;

    updateWeightLoss();
  }

  /**
   * Update color progress bar
   */
  function updateProgress() {
    const percentage = ((weightSlider.value - minWeight) / (maxWeight - minWeight)) * 100;
    weightSliderProgress.style.width = percentage + '%';
  }

  /**
   * Update when slider changes
   */
  weightSlider.addEventListener('input', function () {
    weightInput.value = this.value;
    updateWeightLoss();
  });

  /**
   * Validate and update when user finishes typing
   */
  weightInput.addEventListener('blur', function () {
    validateInput();
    weightSlider.value = weightInput.value;
  });

  updateWeightLoss();
}
